export default __webpack_public_path__ + "static/media/plane2.a6d38af8.png";